import { cleanText } from "./cleanText.js";
export function parseText(source, initialStart, regexp = /^[0-9A-Z<]+$/) {
    const cleaned = cleanText(source);
    if (!regexp.test(source)) {
        throw new ParseTextError(`invalid text: ${source}. Must match the following regular expression: ${regexp.toString()}`, cleaned, initialStart, initialStart + cleaned.length);
    }
    return cleaned;
}
export class ParseTextError extends Error {
    value;
    start;
    end;
    constructor(message, value, start, end) {
        super(message);
        this.value = value;
        this.start = start;
        this.end = end;
    }
}
//# sourceMappingURL=parseText.js.map